import { generateClientToken } from "./token.client.js";
import { getBaseUrl, getPathName, isLocal, timestampToUTC } from "../../lib/Utils"
import { fectServiceApi } from "../../lib/fetchServiceApi"
import { BEATS_PULSE_URL, DRUID_CLIENT, ENTRY_POINT_ID } from "../../config.js";

const PROVIDER_ID = 'librero-web-site';
const PROVIDER_ID_NAME = 'el_librero';
const PROVIDER_DISPLAY_NAME = 'El Librero Connector';
const DISPLAY_NAME = 'ellibrero.com';

async function goToPayEvent(data){
    let body = {
      "published": timestampToUTC(Date.now()),
      "actor":{
        "objectType": "person",
        "schemaOrg": {
        },
        "externalIds": {
          "druid:objectid": localStorage.getItem('druid_user_id')
        }
      },
      "verb": "click",
      "object": {
        "url": window.location.href,
        "displayName": data.objectDisplayName,
        "objectType": "link"
      },
      "target": {
        "id": localStorage.getItem('shopifyCartId'),
        "objectType": "page",
        "url": data.urlTarget,
        "displayName": data.targetDisplayName
      },
      "origin":{
          "_id": 'button:proceder-pago',
          "objectType": "entrypoint",
          "displayName": data.originDisplayName,
          "application":{
            "_id": PROVIDER_ID,
            "objectType": "application",
            "displayName": DISPLAY_NAME
          }
       },
       "provider" : {
        "id": PROVIDER_ID_NAME,
        "objectType": "application",
        "displayName": PROVIDER_DISPLAY_NAME
      }
    };

    if(!body.actor.externalIds['druid:objectid']){
      return false;
    }

    callService(body);
}

async function visitOfferSection(data){
  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType":"person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb":"watch",
    "object": {
      "id": 'slug:ofertas',
      "url": window.location.href,
      "displayName": data.objectDisplayName,
      "objectType": "page"
    },
    "origin":{
        "_id": 'slug:ofertas',
        "objectType": "entrypoint",
        "displayName": data.originDisplayName,
        "application":{
          "_id": PROVIDER_ID,
          "objectType": "application",
          "displayName": DISPLAY_NAME
        }
     },
    "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };

  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

async function visitPdp(data){ 
  let sanityData = data.sanityData;
  let product = data.product;

  const categories = ()=>{
    let categories = [];

    if(sanityData?.tags[0]?.title){
      categories.push(sanityData?.tags[0]?.title);
    }

    if(sanityData?.tags[1]?.title){
      categories.push(sanityData?.tags[1]?.title);
    }

    if(sanityData?.tags[2]?.title){
      categories.push(sanityData?.tags[2]?.title);
    }

    if(sanityData?.tags[3]?.title){
      categories.push(sanityData?.tags[3]?.title);
    }

    return categories;
  };

  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType":"person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb":"watch",
    "object": {
      "id": sanityData?.store?.id,
      "objectDisplayName": data.objectDisplayName,
      "objectType": "product",
      "schemaOrg": {
          "identifier": sanityData.store.options[0].values[0],
          "serialNumber": product?.variants.nodes[0].title,
          "url": location.href,
          "name": sanityData?.store?.title,
          "releasedDate": sanityData._createdAt,
          "categories": categories(),
          "sku": sanityData?.store?.id,
          "totalPayment": {
              "price": sanityData?.store?.priceRange.maxVariantPrice,
              "priceCurrency":"MXN"
          }
      }
    },
    "origin":{
      "_id": 'slug:'+sanityData.slug,
      "objectType": "entrypoint",
      "displayName": data.originDisplayName,
      "application":{
        "_id": PROVIDER_ID,
        "objectType": "application",
        "displayName": DISPLAY_NAME
      }
    },
     "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  await callService(body);
}

async function visitCategory(data){
  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType":"person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb": "watch",
    "object": {
      "id": getPathName(),
      "url": window.location.href,
      "displayName": data.objectDisplayName,
      "objectType": "page",
      "schemaOrg": {
        "breadcrumb": "categorias"
      }
    },
    "origin":{
        "_id": "slug:"+ getPathName(),
        "objectType":"entrypoint",
        "displayName": data.originDisplayName,
        "application":{
          "_id": PROVIDER_ID,
          "objectType": "application",
          "displayName": DISPLAY_NAME
        }
     },
    "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

async function visitEtiqueta(data){
  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType":"person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb":"watch",
    "object": {
      "id": getPathName(),
      "url": window.location.href,
      "displayName": data.objectDisplayName,
      "objectType": "page",
      "schemaOrg": {
        "breadcrumb": "etiqueta"
      }
    },
    "origin":{
        "_id": 'slug:'+ getPathName(),
        "objectType":"entrypoint",
        "displayName": data.originDisplayName,
        "application":{
          "_id": PROVIDER_ID,
          "objectType": "application",
          "displayName": DISPLAY_NAME
        }
     },
    "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

async function visitColeccion(data){
  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType":"person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb":"watch",
    "object": {
      "id": data.page?._id,
      "url": window.location.href,
      "displayName": data.page?.pageTitle,
      "objectType": "page",
      "schemaOrg": {
        "breadcrumb": "coleccion"
      }
    },
    "origin":{
        "_id": 'slug:'+getPathName(),
        "objectType":"entrypoint",
        "displayName": data.originDisplayName,
        "application":{
          "_id": DRUID_CLIENT,
          "objectType": "application",
          "displayName": DISPLAY_NAME
        }
     },
    "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

async function addGiftNote(data){

  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType":"person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb":"post",
    "object": {
      "id": data.shopifyCartId,
      "displayName": data.objectDisplayName,
      "objectType": "collection",
    },
    "origin":{
        "_id": location.href,
        "objectType": "entrypoint",
        "displayName": data.originDisplayName,
        "application":{
           "_id": PROVIDER_ID,
           "objectType":"application",
           "displayName": DISPLAY_NAME
        }
    },
    "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

async function addProducCart(data){
  let sanityData = data.sanityData;
  let product = data.product;

  const categories = ()=>{
    let categories = [];

    if(sanityData?.tags[0]?.title){
      categories.push(sanityData?.tags[0]?.title);
    }

    if(sanityData?.tags[1]?.title){
      categories.push(sanityData?.tags[1]?.title);
    }

    if(sanityData?.tags[2]?.title){
      categories.push(sanityData?.tags[2]?.title);
    }

    if(sanityData?.tags[3]?.title){
      categories.push(sanityData?.tags[3]?.title);
    }

    return categories;
  };

  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType":"person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb":"add",
    "object": {
      "id": sanityData?.store?.id,
      "objectType": "product",
        "schemaOrg": {
            "identifier": sanityData.store.options[0].values[0],
            "serialNumber": product?.variants?.nodes[0]?.title,
            "url": location.href,
            "name": sanityData?.store?.title,
            "releasedDate": sanityData._createdAt,
            "categories": categories(),
            "sku": sanityData?.store?.id,
            "totalPayment": {
                "price": sanityData?.store?.priceRange.maxVariantPrice,
                "priceCurrency":"MXN"
            }
        }
    },
    "origin":{
        "_id":'slug:'+ (sanityData._id) ? sanityData._id : sanityData.slug,
        "objectType":"entrypoint",
        "displayName": data.originDisplayName,
        "application":{
           "_id": DRUID_CLIENT,
           "objectType":"application",
           "displayName": DISPLAY_NAME
        }
     },
     "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

async function openSiteEbook(data){
  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType": "person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb": "click",
    "object": {
      "url": window.location.href,
      "displayName": data.objectDisplayName,
      "objectType": "link"
    },
    "target": {
      "id": "ofertas",
      "objectType": "page",
      "url": window.location.href,
      "displayName": data.targetDisplayName
    },
    "origin":{
        "_id": 'slug:account',
        "objectType": "entrypoint",
        "displayName": data.originDisplayName,
        "application":{
          "_id": PROVIDER_ID,
          "objectType": "application",
          "displayName": DISPLAY_NAME
        }
     },
    "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

async function visitBlogPost(data){
  let page = data.page;

  const categories = ()=>{
    let categories = [];

    for(let category of page.categories){
      categories.push(category.name)
    }

    return categories;
  };

  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType":"person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb":"watch",
    "object": {
      "id": page._id,
      "objectType": "page",
        "schemaOrg": {
            "identifier": page._id,
            "url": location.href,
            "name": page.seoTitle,
            "releasedDate": page._createdAt,
            "categories": categories(),
        }
    },
    "origin":{
        "_id": "slug:"+ getPathName(),
        "objectType":"entrypoint",
        "displayName": data.originDisplayName,
        "application":{
          "_id": PROVIDER_ID,
          "objectType": "application",
          "displayName": DISPLAY_NAME
        }
     },
    "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

async function openFragment(data){
  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType": "person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb": "click",
    "object": {
      "url": window.location.href,
      "displayName": data.objectDisplayName,
      "objectType": "link"
    },
    "target": {
      "id": data.product.id,
      "objectType": "page",
      "url": data.urlFragment,
      "displayName": data.targetDisplayName
    },
    "origin":{
        "_id": 'slug:'+data.product.handle,
        "objectType": "entrypoint",
        "displayName": data.originDisplayName,
        "application":{
           "_id": DRUID_CLIENT,
           "objectType": "application",
           "displayName": DISPLAY_NAME
        }
    },
    "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

async function addProductWishList(data){
  let product = data.product;

  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType":"person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb":"add",
    "object": {
      "id": product.id,
      "objectType": "product",
        "schemaOrg": {
            "serialNumber": product?.isbn,
            "url": location.href,
            "name": product?.title,
            "totalPayment": {
                "price": product?.priceRange.maxVariantPrice.amount,
                "priceCurrency":"MXN"
            }
        }
    },
    "origin":{
        "_id":"pagina_de_producto",
        "objectType":"entrypoint",
        "displayName": data.originDisplayName,
        "application":{
           "_id": DRUID_CLIENT,
           "objectType":"application",
           "displayName": DISPLAY_NAME
        }
     },
    "provider" : {
      "id": PROVIDER_ID_NAME,
      "objectType": "application",
      "displayName": PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

async function removeProducCart(data){
  let product = data.product;

  let body = {
    "published": timestampToUTC(Date.now()),
    "actor":{
      "objectType":"person",
      "schemaOrg": {
      },
      "externalIds": {
        "druid:objectid": localStorage.getItem('druid_user_id')
      }
    },
    "verb":"add",
    "object": {
      "id": product.id,
      "objectType": "product",
        "schemaOrg": {
            "name": product.product.title,
            "totalPayment": {
                "price": product?.priceV2.amount,
                "priceCurrency":"MXN"
            }
        }
    },
    "origin":{
        "_id":"pagina_de_producto",
        "objectType":"entrypoint",
        "displayName": data.originDisplayName,
        "application":{
           "_id": DRUID_CLIENT,
           "objectType":"application",
           "displayName": DISPLAY_NAME
        }
     },
    "provider" : {
      "id" : PROVIDER_ID,
      "objectType" : "application",
      "displayName" : PROVIDER_DISPLAY_NAME
    }
  };
  
  if(!body.actor.externalIds['druid:objectid']){
    return false;
  }

  callService(body);
}

export async function sendPulseEvent(nameEvent, data){
  if(nameEvent == 'goToPayEvent'){ await goToPayEvent(data);}
  else if(nameEvent == 'visitOfferSection'){ await visitOfferSection(data);}
  else if(nameEvent == 'visitPdp'){ await visitPdp(data);}
  else if(nameEvent == 'visitCategory'){ await visitCategory(data);}
  else if(nameEvent == 'visitEtiqueta'){ await visitEtiqueta(data);}
  else if(nameEvent == 'visitColeccion'){ await visitColeccion(data);}
  else if(nameEvent == 'addGiftNote'){ await addGiftNote(data);} 
  else if(nameEvent == 'addProducCart'){ await addProducCart(data);} 
  else if(nameEvent == 'openSiteEbook'){ await openSiteEbook(data);} 
  else if(nameEvent == 'visitBlogPost'){ await visitBlogPost(data);} 
  else if(nameEvent == 'openFragment'){ await openFragment(data);} 
  else if(nameEvent == 'addProductWishList'){ await addProductWishList(data);}
  else if(nameEvent == 'removeProducCart'){ await removeProducCart(data);}
}

async function callService(data){
  let token = await generateClientToken();

  console.log('Event body', data)

  if(isLocal()){
    return await fectServiceApi(getBaseUrl() + '/api/dru-id/mockup-pulse',{
      data: JSON.stringify(data),
      token: token
    })
    .then((response)=>{
      return response;
    })     
  }else{
    let endpointUrl = BEATS_PULSE_URL+'identities';
    await fetch(endpointUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
      },
      body: JSON.stringify(data)
    }).then((res) => {
      if (res.status === 200) {
        return res?.json();
      } else {
        throw new Error('It was not possible to send the event. token:'+token);
      }
    });
  }
}